export default __webpack_public_path__ + "static/media/ncl_woodline.71822a1f.jpg";